import { getKeys } from '../../../translations/keys';

export const tk = getKeys('enumLng');
export const tkVal = getKeys('commonLng');
